import { render } from "./DialogPurchaseFailed.vue?vue&type=template&id=6192c69b"
import script from "./DialogPurchaseFailed.vue?vue&type=script&lang=js"
export * from "./DialogPurchaseFailed.vue?vue&type=script&lang=js"
script.render = render

export default script